import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  selectHorseDialog: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "100%",
      width: "100%",
      margin: 0
    },
    "& .MuiPaper-rounded": {
      borderRadius: 0
    },
    "& .MuiDialog-paperScrollPaper": {
      height: "100%",
      maxHeight: "100%"
    },
    "& .MuiBackdrop-root": {
      left: 48
    },
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  header: {
    alignItems: "center",
    borderRadius: 0,
    padding: "8px 16px 16px",
    height: "104px",
    boxShadow: "3px 1px 7px 0px rgba(0, 0, 0, 0.15)",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.common.white
  },
  topBar: {
    justifyContent: "space-between",
    flexWrap: "nowrap",
    alignItems: "center",
    marginBottom: 37
  },
  topBarTitle: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 19
  },
  arrowIcon: {
    color: "black",
    transform: "rotate(270deg)",
    fontSize: "16px",
    marginLeft: 4,
    cursor: "pointer"
  },
  itemsList: {
    top: 160,
    height: "calc(100vh - 160px)"
  },
  cancelButtonWrapper: {
    textAlign: "right"
  },
  cancelButton: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.secondary,
    fontSize: 16,
    textDecoration: "none"
  },
  formContent: {
    zIndex: 10,
    top: 110,
    left: 16,
    position: "fixed",
    [theme.breakpoints.down(Breakpoints.SS_320)]: {
      minWidth: 280,
      width: "90%"
    },
    [theme.breakpoints.up(Breakpoints.XS_420)]: {
      width: 380
    },
    [theme.breakpoints.up(Breakpoints.SM_600)]: {
      top: 118
    }
  }
}));
